<template>
  <div class="planned-transaction-layout-compact-block">
    <div class="planned-transaction-layout-compact">
      <div>
        <AccountIcon :icon="transaction.template.account.icon"
                     class="w-16 h-16 float-left inline-block"
                     :class="{'opacity-50':applyOpacity}"
                     iconClass="text-xl"/>
        <div class="flex flex-wrap">
          <AccountName :name="transaction.template.account.title"
                       :class="{'opacity-50':applyOpacity}"
                       class="pt-1-5 mb-2 w-full"/>
          <div class="flex max-w-full">
            <Category :category="transactionCategory"
                      v-if="transactionCategory"
                      :class="{'opacity-50':applyOpacity}"
                      class="flex-none mr-2-5 inline-block"/>
            <Comment v-if="transaction.template.comment"
                     :transaction="transaction.template"
                     :comment="transaction.template.comment"
                     :class="{'opacity-50':applyOpacity}"
                     class="inline-block text-xs"/>
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="w-full">
          <div class="flex justify-end pt-1-5">
            <Value :sum="transaction.template.sum"
                   :currency="transaction.template.account.currency"
                   :isExpense="transaction.template.type === 2 || transaction.template.type === 4"
                   :class="{'opacity-50':applyOpacity}"
                   :type="type"/>

          </div>
          <div class="flex flex-wrap items-start justify-end">
            <Contractor v-if="!!transaction.template.contractor && displayContractor"
                        :contractor="transaction.template.contractor"
                        :class="{'opacity-50':applyOpacity}"
                        class="mt-1-5"/>
            <Tags v-if="!!transaction.template.tags.length"
                  :tags="transaction.template.tags"
                  :type="type"
                  class="flex-wrap justify-end"
                  :class="{'opacity-50':applyOpacity}"
                  tag-class="mt-1-5"/>
          </div>
        </div>
        <PlannedActions v-if="!currentUserIsWatcher"
                        class="flex-col row-gap-3"
                        @confirm="$emit('confirm')"
                        @edit="$emit('edit')"/>
      </div>
    </div>
  </div>
</template>

<script>
import AccountIcon from "@/components/common/Transaction/TransactionItem/AccountIcon";
import AccountName from "@/components/common/Transaction/TransactionItem/AccountName";
import Category from "@/components/common/Transaction/TransactionItem/Category";
import Comment from "@/components/common/Transaction/TransactionItem/Comment";
import Contractor from "@/components/common/Transaction/TransactionItem/Contractor";
import Tags from "@/components/common/Transaction/TransactionItem/Tags";
import Value from "@/components/common/Transaction/TransactionItem/Value";
import Actions from "@/components/common/Transaction/TransactionItem/Actions";
import StatusPending from "@/components/common/Transaction/TransactionItem/StatusPending";
import {mapGetters} from "vuex";
import PlannedActions from "@/components/common/PlannedTransaction/PlannedTransactionItem/PlannedActions";

export default {
  name: "PlannedTransactionViewCompact",
  components: {
    PlannedActions,
    StatusPending, AccountName, AccountIcon, Category, Comment, Contractor, Tags, Value, Actions
  },
  props: {
    transaction: {
      type: Object,
      required: true
    },
    applyOpacity: {
      type: Boolean,
      default: false
    },
    displayContractor: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    type() {
      return this.transaction.template.type === 1 ? 'income' : 'expense'
    },
    transactionCategory() {
      if (this.transaction.template.type === 1) {
        return this.transaction.template.income;
      } else {
        return this.transaction.template.expense;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.planned-transaction-layout-compact-block {
  @apply relative py-6 -mx-2 pl-2;
  margin-bottom: -1px;

  &:not(:last-of-type):after {
    @apply bg-border rounded w-full left-0 absolute rounded;
    content: '';
    height: 1px;
    bottom: 1px;
  }
}

.planned-transaction-layout-compact {
  @apply grid grid-cols-2;
}
</style>